













































































































import Vue from 'vue';
import { EventBus } from '@/event-bus';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { addEditShipmentMixin } from '@/mixins/shipments/addEditShipment';
import { addEditSpotMarketBidMixin } from '@/mixins/shipments/addEditSpotMarketBid';
import { authMixin } from '@/mixins/auth';
import { animationMixin } from '@/mixins/animation';

import { PendingOrderDetailsResponse } from '@/models/shipments/addOrEdit/responses/PendingOrderDetailsResponse';
import { SavePendingOrderResponse } from '@/models/shipments/addOrEdit/responses/SavePendingOrderResponse';
import SavedPendingOrderPrompt from '../shipments/SavedPendingOrderPrompt.vue';

import accountService from '@/services/AccountsService';
import pendingOrderService from '@/services/PendingOrderService';
import shipmentsService from '@/services/ShipmentsService';
import localStorageService from '@/services/LocalStorageService';

export default Vue.extend<any, any, any, any>({
  components: { SavedPendingOrderPrompt },
  mixins: [
    iconsMixin,
    breakpointsMixin,
    addEditShipmentMixin,
    addEditSpotMarketBidMixin,
    authMixin,
    animationMixin,
  ],
  data() {
    return {
      showLoadingScreen: false,
      loadingScreenMessage: '',
      serverErrors: '',
      showConfirmCancelPopup: false,
      showPendingOrderSummaryPopup: false,
      showSendBidToCarriersSummaryPopup: false,
      showSaveShipmentServerErrorsPopup: false,
      showSavedShipmentScreen: false,
      showNoCarrierRatesPopup: false,
      showBookValidationSummaryPopup: false,
      justCreatedOrderId: null,
      justCreatedShipmentId: null,
      leavingSoon: null,
      showBidSentScreen: false,
      showWelcomeBackScreen: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.showWelcomeBackScreen = true;

      // reset form & set smb mode
      this.$store.commit('shipments/resetShipmentForm');
      this.$store.commit('shipments/setServiceType', 6); // smb

      this.showLoadingMessage('Personalizing your shipment experience');

      // check if we need to load details from backend
      this.loadDetails();

      EventBus.$on('new-shipment-step-changed', this.stepChanged);
      EventBus.$on('cancel-new-shipment', this.cancelShipment);
    },
    loadDetails() {
      const shipmentId = this.$route.params.bidId;
      if (shipmentId && !shipmentId.startsWith('SM0')) {
        this.justSavedOrderId = shipmentId;
        pendingOrderService
          .getDetailsById(shipmentId)
          .then((x: PendingOrderDetailsResponse) => {
            this.populateControlsWithPendingOrderInfo(x);
            this.stopLoading();

            this.setWhereUserLeft();
          });
      }
    },
    populateControlsWithPendingOrderInfo(x: PendingOrderDetailsResponse) {
      this.$store.commit('shipments/mapPendingOrderToShipment', x);

      // load data in other components
      EventBus.$emit('shipment-form-details-loaded');
    },
    saveAndSendRequestsToCarriers() {
      this.$store.commit('shipments/validatePendingOrder');
      this.$store.commit('shipments/distributeCarrierEmails');

      if (this.pendingOrderValidationErrors.length) {
        this.showSendBidToCarriersSummaryPopup = true;
        this.showPendingOrderSummaryPopup = false;
        this.scrollTop();
      } else {
        this.showLoadingMessage('One sec!<br/>Processing your bid...');

        pendingOrderService
          .create(this.saveShipmentRequest)
          .then((x: SavePendingOrderResponse) => {
            /* istanbul ignore if */
            if (!x.success) {
              this.serverErrors = x.error;
              this.showSaveShipmentServerErrorsPopup = true;
              localStorageService.remove('smb-po-' + x.orderId + '-carriers');
            } else {
              window.location.href = '/customer/spot-market/your-bid-sent';
            }
          })
          .catch(this.handleCreateOrderErrors)
          .finally(() => {
            this.stopLoading();
          });
      }
    },
    loadDefaultForm() {
      /* istanbul ignore next */
      setTimeout(() => {
        EventBus.$emit('shipment-form-location-and-time-init');
      }, 200);

      this.saveShipmentRequest.userId = this.user.userId;
      accountService.getAccountById(this.user.accountId).then((x) => {
        this.saveShipmentRequest.setBillTo(x);
      });

      // add default piece
      if (!this.saveShipmentRequest.packages.length)
        this.$store.commit('shipments/addNewPiece');
    },
    stepChanged(newStep) {
      this.$store.commit('shipments/setStep', newStep);

      // notify review components
      if (newStep == 6) {
        EventBus.$emit(
          'new-shipment-review-update-blocks',
          this.saveShipmentRequest
        );
      }
    },
    cancelShipment() {
      this.showConfirmCancelPopup = true;
    },
    saveAndReload() {
      this.sendCreateOrderRequest();
    },
    saveForLater() {
      this.$store.commit('shipments/validatePendingOrder');

      /* istanbul ignore next */
      // allow to save if there are no rates
      this.saveShipmentRequest.pendingOrderErrors =
        this.saveShipmentRequest.pendingOrderErrors.filter(
          (x) => x.title != 'Target Rate'
        );

      if (this.saveShipmentRequest.pendingOrderErrors.length) {
        this.showPendingOrderSummaryPopup = true;
        this.showSendBidToCarriersSummaryPopup = false;
        this.scrollTop();
      } else {
        this.leavingSoon = true;
      }
    },
    showLoadingMessage(message) {
      this.loadingScreenMessage = message;
      this.showLoadingScreen = true;
    },
    sendCreateOrderRequest() {
      this.showLoadingMessage('Saving your pending order');

      pendingOrderService
        .create(this.saveShipmentRequest)
        .then((x: SavePendingOrderResponse) => {
          this.finishCreatingPendingOrder(x);
        })
        .catch(this.handleCreateOrderErrors)
        .finally(() => {
          this.stopLoading();
        });
    },
    handleCreateOrderErrors(x) {
      let errorMsg = 'Sorry, something went wrong';
      if (x.response && x.response.data && x.response.data.message) {
        errorMsg = x.response.data.message;
        this.serverErrors = errorMsg;
        this.showSaveShipmentServerErrorsPopup = true;
      }
    },
    continueEditing() {
      this.showWelcomeBackScreen = false;
      this.setWhereUserLeft();
    },
    finishCreatingPendingOrder(x: SavePendingOrderResponse) {
      /* istanbul ignore if */
      if (!x.success) {
        this.serverErrors = x.error;
        this.showSaveShipmentServerErrorsPopup = true;
      } else {
        this.justCreatedOrderId = x.orderId;
        EventBus.$emit('save-selected-carriers', x.orderId);

        this.saveCurrentTab(x.orderId);
        this.openSpotMarketDashboard();
      }
    },
    openSpotMarketDashboard() {
      window.location.href = '/customer/spot-market?tab=Bids+In+Progress';
    },
    book() {
      this.showLoadingMessage('One Sec! <br/> Processing your order...');

      /* istanbul ignore next */
      shipmentsService
        .book(this.saveShipmentRequest)
        .then((x: SavePendingOrderResponse) => {
          this.finishBooking(x);
        })
        .catch((x) => {
          this.catchBookingShipmentError(x);
        });
    },
    finishBooking(x: SavePendingOrderResponse) {
      if (!x.success) {
        this.serverErrors = x.error;
        this.showSaveShipmentServerErrorsPopup = true;
      } else {
        this.justCreatedShipmentId = x.shipmentId;
        this.showSavedShipmentScreen = true;
      }

      this.stopLoading();
    },
    catchBookingShipmentError(x) {
      if (x.response && x.response.data && x.response.data.message) {
        this.serverErrors = x.response.data.message;
      } else {
        this.serverErrors = 'Sorry, something went wrong';
      }

      this.showSaveShipmentServerErrorsPopup = true;
      this.stopLoading();
    },
    stopLoading() {
      this.loadingScreenMessage = '';
      this.showLoadingScreen = false;
    },
  },
  computed: {
    pendingOrderValidationErrors() {
      return this.saveShipmentRequest.pendingOrderErrors;
    },
    saveShipmentServerErrors() {
      return this.serverErrors;
    },
    orderId() {
      return this.justCreatedOrderId;
    },
    shipmentId() {
      return this.justCreatedShipmentId;
    },
  },
});
